import type { TableNoDataTheme } from '../TableNoDataStyles.css';

import { tableNoDataStyles, variants } from '../TableNoDataStyles.css';
import { multiVariantStyles } from './TableNoDataVariants.css';

export const TableNoDataRedwoodTheme: TableNoDataTheme = {
  multiVariantStyles,
  variants,
  styles: tableNoDataStyles
};
